import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { useSubscriptionLimit } from "@/hooks/useSubscriptionLimit";

interface ProductActionsSectionProps {
  onAddProduct: () => void;
  onDeleteProduct: () => void;
}

export const ProductActionsSection = ({ onAddProduct, onDeleteProduct }: ProductActionsSectionProps) => {
  const { subscription, isLoading, currentLimit } = useSubscriptionLimit();

  return (
    <div className="flex justify-between items-center">
      <div className="text-sm text-gray-500">
        {!isLoading && subscription && (
          <span>
            Plan {subscription.plan} - {currentLimit === -1 ? "Produits illimités" : `${currentLimit} produits maximum`}
          </span>
        )}
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onDeleteProduct} className="text-red-500 hover:text-red-600 hover:bg-red-50">
          <Trash2 className="w-4 h-4 mr-2" />
          Supprimer un produit
        </Button>
        <Button onClick={onAddProduct}>
          <Plus className="w-4 h-4 mr-2" />
          Ajouter un produit
        </Button>
      </div>
    </div>
  );
};